import React from 'react';
import { useLeadModal } from '../context/LeadModalContext';

export default function StickyCTA() {
  const { openModal } = useLeadModal();

  return (
    <div className="sticky-cta" role="region" aria-label="Early access">
      <div className="sticky-cta-inner container">
        <p className="sticky-cta-text">
          <strong>Notrack</strong> — weight loss without calorie counting. Lock founding pricing.
        </p>
        <button type="button" className="btn btn-primary sticky-cta-btn" onClick={() => openModal('Founding Plan')}>
          👉 Lock Early Access
        </button>
      </div>
    </div>
  );
}
